import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import Dialog from './Dialog';
import FormField from './FormField';
import Button from './Button';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function LeadCaptureDialog({ visible, onClose, onSubmit, responseStatus }) {
  const [form, setForm] = useState({ name: '', email: '', jobTitle: '', company: '' });
  const [errors, setErrors] = useState({});

  const update = (key) => (val) => setForm((f) => ({ ...f, [key]: val }));

  const validate = () => {
    const next = {};
    if (!form.name.trim()) next.name = 'Required';
    if (!form.email.trim()) next.email = 'Required';
    else if (!emailPattern.test(form.email.trim())) next.email = 'Enter a valid email';
    if (!form.jobTitle.trim()) next.jobTitle = 'Required';
    if (!form.company.trim()) next.company = 'Required';
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit(form);
  };

  // Close and reset only once the submission actually succeeds.
  useEffect(() => {
    if (responseStatus === 200) {
      setForm({ name: '', email: '', jobTitle: '', company: '' });
      setErrors({});
      onClose?.();
    }
  }, [responseStatus]);

  const submissionError =
    responseStatus === 400 ? 'Please check your details and try again.' :
    responseStatus >= 500 ? "Sorry, something went wrong on our end. Please try again shortly." :
    responseStatus === 0 ? 'Could not connect. Check your internet and try again.' :
    null;

  return (
    <Dialog
      title="Book a demo"
      visible={visible}
      onClose={onClose}
      footer={
        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: 12 }}>
          <Button variant="secondary" size="md" onPress={onClose}>Cancel</Button>
          <Button variant="primary" size="md" onPress={handleSubmit}>Submit</Button>
        </View>
      }
    >
      <FormField label="Name" value={form.name} onChangeText={update('name')} placeholder="Jane Smith" error={errors.name} />
      <FormField label="Email" value={form.email} onChangeText={update('email')} placeholder="jane@company.com" keyboardType="email-address" autoCapitalize="none" error={errors.email} />
      <FormField label="Job Title" value={form.jobTitle} onChangeText={update('jobTitle')} placeholder="Head of Marketing" error={errors.jobTitle} />
      <FormField label="Company" value={form.company} onChangeText={update('company')} placeholder="Marketing Inc." error={errors.company} />
      {submissionError && <Text style={{ color: '#b00020', marginTop: 8 }}>{submissionError}</Text>}
    </Dialog>
  );
}